import { KpiKeys } from '@models';

export const environment = {
  production: false,
  SMART_LICENSE_KEY: '575F232B-93C7-4D9B-AD15-296DB0C585BE',
  ENVIRONMENT_URL: 'https://test.apps.thermofisher.com',
  CRG_DIGITALIZATION_SERVICE_URL: 'https://test.apps.thermofisher.com/api/crg-sponsor-portal-service-non-prod/api',
  USER_DETAILS_URL: 'https://test.apps.thermofisher.com/dhap-amp/api/v2/user/userDetails',
  ENTITLEMENTS_URL:
    'https://test.apps.thermofisher.com/api/de-eec-subscription/v1/user/entitlements',
  CRG_HOME: 'https://clinical-decision-suite.cds-test.thermofisher.com/home',
  KPI_CHART_DATA_TIMEOUT: 7000
};

export const featureFlags = {
  enableUserSessionMonitoring: true,
  enableStudyInsights: false,
  enableStudyInsightsVariants: true,
  hiddenKPIs: [] as KpiKeys[],
  hiddenDrilldownCharts: [] as KpiKeys[]
};
